import React from "react";

export default function Footer() {
  return (
    <div className="footer">
  <div className="card-footer py-4 fs-5 bg-dark text-light text-center">
  © 2023 Copyright ⭐ Portfolio.com
  </div>
    </div>
  );
}
